import accountStore from '@/stores/account.store'
import { MetadataKey } from '@/enums'
import type { WizardSavedProgress } from '@/modules/wizard/types/WizardSavedProgress'

class WizardFlowService {
  public saveProgress(flowName: string, stepId: string): void {
    const flowProgress = { ...this.readAll() }
    flowProgress[flowName] = stepId

    accountStore
      .updateMetadata(MetadataKey.FLOWS, flowProgress)
      .catch((error) => {
        console.error('Failed to save wizard progress:', error)
      })
  }

  public getProgress(flowName: string): WizardSavedProgress | null {
    const saved = this.readAll()[flowName]

    return typeof saved === 'string' || typeof saved === 'number' ? saved : null
  }

  public clearProgress(flowName: string): void {
    const metadata = accountStore.state.account.metadata
    const existing = metadata[MetadataKey.FLOWS]

    if (existing && typeof existing === 'object' && !Array.isArray(existing)) {
      const flowProgress = { ...existing }
      delete flowProgress[flowName]

      accountStore
        .updateMetadata(MetadataKey.FLOWS, flowProgress)
        .catch((error) => {
          console.error('Failed to clear wizard progress:', error)
        })
    }
  }

  private readAll(): Record<string, unknown> {
    const existing = accountStore.state.account.metadata[MetadataKey.FLOWS]

    return existing && typeof existing === 'object' && !Array.isArray(existing)
      ? (existing as Record<string, unknown>)
      : {}
  }
}

export default new WizardFlowService()
